var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMentionAt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6209_43782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6654 5.33357V8.6669C10.6654 9.19734 10.8761 9.70605 11.2512 10.0811C11.6262 10.4562 12.1349 10.6669 12.6654 10.6669C13.1958 10.6669 13.7045 10.4562 14.0796 10.0811C14.4547 9.70605 14.6654 9.19734 14.6654 8.6669V8.00024C14.6653 6.49559 14.1562 5.03522 13.2209 3.85659C12.2856 2.67796 10.9791 1.85039 9.5138 1.50844C8.04852 1.16648 6.51066 1.33027 5.15027 1.97315C3.78988 2.61603 2.68697 3.70021 2.02088 5.04939C1.35478 6.39856 1.16468 7.9334 1.48148 9.40431C1.79828 10.8752 2.60335 12.1957 3.76579 13.1511C4.92823 14.1064 6.37966 14.6405 7.88408 14.6663C9.38851 14.6922 10.8574 14.2084 12.052 13.2936M10.6654 8.00024C10.6654 9.473 9.47146 10.6669 7.99871 10.6669C6.52595 10.6669 5.33204 9.473 5.33204 8.00024C5.33204 6.52748 6.52595 5.33357 7.99871 5.33357C9.47146 5.33357 10.6654 6.52748 10.6654 8.00024Z",
    stroke: "#EE4266",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6209_43782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentionAt);
export default __webpack_public_path__ + "static/media/mention-at.ab16cadb774a0e024bf80cfbef4ad801.svg";
export { ForwardRef as ReactComponent };